/** Textos do painel em português. É a fonte: en e es têm de ter a mesma forma. */
export const ptBR = {
  common: {
    save: 'Salvar',
    cancel: 'Cancelar',
    close: 'Fechar',
    back: 'Voltar',
    add: 'Adicionar',
    remove: 'Remover',
    edit: 'Editar',
    confirm: 'Confirmar',
    loading: 'Carregando',
    retry: 'Tentar de novo',
    refresh: 'Atualizar',
    actions: 'Ações',
    details: 'Detalhes',
    none: 'Nenhum',
    na: 'n/d',
    yes: 'Sim',
    no: 'Não',
    all: 'Todos',
    optional: 'opcional',
    readOnly: 'Somente leitura',
    loadError: 'Não foi possível carregar.',
    correlation: 'Código para o suporte: {{id}}',
    saved: 'Salvo.',
    required: 'Obrigatório.',
    unsaved: 'Há alterações não salvas. Sair mesmo assim?',
    unsavedBadge: 'Alterações não salvas',
  },
  errors: {
    network: 'Sem conexão com o serviço. Confira a rede e tente de novo.',
    forbidden: 'Seu papel não permite esta ação.',
    conflict: 'Outra pessoa salvou antes. Os dados foram recarregados; refaça a mudança.',
    session: 'Sua sessão terminou. Entre de novo.',
    invalidResponse: 'O serviço respondeu num formato inesperado. Atualize o painel; se continuar, abra um chamado.',
    generic: 'Não foi possível concluir.',
  },
  nav: {
    label: 'Menu principal',
    skip: 'Pular para o conteúdo',
    overview: 'Visão geral',
    connections: 'Conexões',
    clients: 'Apps',
    users: 'Usuários',
    collapse: 'Recolher menu',
    expand: 'Expandir menu',
    groups: {
      context: 'Contexto',
      channels: 'Canais',
      audit: 'Auditoria',
      admin: 'Administração',
    },
    chat: 'Chat no navegador',
    teams: 'Ask no Teams',
    mcp: 'Conectores (Claude, GPT)',
    audit: 'Consultas ao Qlik',
    conversations: 'Conversas',
    appearance: 'Aparência',
    settings: 'Configurações',
    ownerNotice: 'Como dono de assunto, você vê os seus apps, com a qualidade de cada um, e as Conversas sobre eles.',
  },
  user: {
    menu: 'Conta e preferências',
    theme: 'Tema',
    themeSystem: 'Seguir o sistema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
    language: 'Idioma',
    logout: 'Sair',
    expires: 'Sessão até {{time}}',
    admin: 'Administrador',
    owner: 'Dono de assunto',
  },
  login: {
    title: 'Entrar no painel',
    subtitle: 'Use a conta da organização. O que você vê depende do seu papel no IdP.',
    sso: 'Entrar com a conta da organização',
    dev: 'Entrar com token de desenvolvimento',
    devHelp: 'Gere com lastrouter dev-token. Só funciona em instalações de desenvolvimento.',
    token: 'Token',
    submit: 'Entrar',
    refused: 'Token recusado. Gere outro e tente de novo.',
    footer: 'Lastrouter: camada de contexto entre os agentes de IA e as fontes de dados.',
  },
  overview: {
    title: 'Visão geral',
    period: 'Últimos 7 dias',
    calls: 'Chamadas',
    users: 'Pessoas',
    answered: 'Respondidas',
    clarifications: 'Pediram esclarecimento',
    errors: 'Erros',
    negative: 'Feedback negativo',
    license: 'Licença',
    publication: 'Catálogo publicado',
    noPublication: 'Nenhuma publicação ainda. Rode lastrouter reload ou publique um rascunho.',
    connections: 'Conexões',
    pending: 'Pendências',
    openDrafts: 'Rascunhos esperando aprovação: {{count}}',
    openFeedback: 'Feedback em aberto: {{count}}',
    nothingPending: 'Nada pendente.',
    publishedBy: 'Publicado por {{by}} em {{at}}',
    commit: 'Commit {{commit}}',
    noCommit: 'Sem commit Git',
  },
  license: {
    valida: 'Válida',
    tolerancia: 'Em tolerância',
    vencida: 'Vencida',
    ausente: 'Sem licença',
    invalida: 'Inválida',
    until: 'Até {{date}}',
  },
  connections: {
    title: 'Conexões',
    subtitle: 'Fontes de dados ligadas ao Lastrouter. As do arquivo de configuração só a TI muda.',
    id: 'Conexão',
    type: 'Tipo',
    target: 'Endereço',
    state: 'Estado',
    checked: 'Verificada em',
    managedBy: 'Gerenciada por',
    arquivo: 'Arquivo',
    painel: 'Painel',
    ok: 'Conectada',
    failed: 'Com falha',
    test: 'Testar como usuário',
    testTitle: 'Testar {{id}}',
    testHelp: 'Informe o usuário como a fonte o conhece (ex.: CLUSTER\\maria). O teste abre cada app como essa pessoa, sem consultar valores.',
    user: 'Usuário da fonte',
    subject: 'Assunto',
    allSubjects: 'Todos os assuntos',
    run: 'Testar',
    summary: 'O usuário {{user}} abre {{ok}} de {{total}} app(s).',
    app: 'App',
    appTitle: 'Título',
    lastReload: 'Última recarga',
    empty: 'Nenhuma fonte configurada.',
  },
  context: {
    title: 'Contexto',
    subtitle: 'O que cada métrica significa, em qual fonte buscar e quais consultas estão validadas.',
    tabPublished: 'Publicado',
    tabDrafts: 'Rascunhos',
    tabHistory: 'Histórico',
    noCatalog: 'Nenhum catálogo publicado ainda.',
    export: 'Exportar zip',
    import: 'Importar zip',
    newDraft: 'Novo rascunho',
    source: 'Fonte',
    app: 'App',
    owners: 'Donos',
    business: 'Negócio',
    technical: 'Técnico',
    metrics: 'Métricas',
    dimensions: 'Dimensões',
    queries: 'Queries validadas',
    playbooks: 'Roteiros de análise',
    unit: 'Unidade',
    expression: 'Expressão',
    synonyms: 'Sinônimos',
    field: 'Campo',
    type: 'Tipo',
    sensitive: 'Dado pessoal',
    certified: 'Certificada',
    notCertified: 'Sem certificação',
    version: 'v{{v}}',
    params: 'Parâmetros',
    required: 'obrigatório',
    optionalParam: 'opcional',
    groupBy: 'Agrupa por',
    when: 'Quando usar',
    steps: 'Passos',
    dimTypes: { texto: 'Texto', periodo_mensal: 'Mês (AAAA-MM)', ano: 'Ano', data: 'Data (período derivado)' },
    history: {
      published: 'Publicada em',
      by: 'Por',
      commit: 'Commit',
      reason: 'Motivo',
      changes: 'Mudanças',
      active: 'Ativa',
      restore: 'Republicar esta versão',
      restoreTitle: 'Republicar {{id}}',
      restoreHelp: 'Volta o catálogo para esta versão. Isso vira uma publicação nova no histórico.',
      restored: 'Versão republicada como {{id}}.',
      restoredFrom: 'volta de {{id}}',
      dirty: 'com mudanças fora do commit',
    },
    drafts: {
      empty: 'Nenhum rascunho. Crie um a partir do catálogo publicado.',
      reason: 'Motivo',
      author: 'Autor',
      created: 'Criado em',
      state: 'Estado',
      subjects: 'Assuntos alterados',
      status: { aberto: 'Aberto', aprovado: 'Aprovado', publicado: 'Publicado', descartado: 'Descartado' },
      newTitle: 'Novo rascunho',
      newHelp: 'O rascunho começa igual ao catálogo publicado. O motivo aparece no histórico e para os donos que vão aprovar.',
      create: 'Criar rascunho',
      open: 'Abrir',
      importTitle: 'Importar zip',
      importHelp: 'Use um zip da pasta de contexto (o mesmo formato do repositório). Ele vira um rascunho; nada é publicado sem aprovação.',
      file: 'Arquivo zip',
      imported: 'Rascunho criado a partir do zip.',
    },
    editor: {
      title: 'Rascunho {{id}}',
      backToDrafts: 'Voltar aos rascunhos',
      readOnly: 'Rascunho {{status}}: só leitura.',
      changes: 'O que muda',
      noChanges: 'Sem mudanças em relação ao catálogo publicado.',
      approvals: 'Aprovações',
      approvalsHelp: 'Cada assunto alterado precisa da aprovação do dono de negócio e do dono técnico.',
      pending: 'Pendente: {{owner}}',
      approvedBy: 'Aprovado por {{by}}',
      refusedBy: 'Recusado por {{by}}',
      approvedInPlace: 'Aprovado por {{by}} no lugar de {{owner}}',
      refusedInPlace: 'Recusado por {{by}} no lugar de {{owner}}',
      substitute: 'Decidir no lugar do dono',
      substituteHelp: '{{owner}} não pode decidir. Como admin, você decide no lugar dele. A decisão fica no histórico com o seu nome e gera um alerta de segurança.',
      reason: 'Motivo',
      approve: 'Aprovar',
      refuse: 'Recusar',
      comment: 'Comentário',
      decisionTitle: '{{decision}} como dono {{papel}} de {{subject}}',
      papelNegocio: 'de negócio',
      papelTecnico: 'técnico',
      publish: 'Publicar',
      publishHelp: 'Publica quando os dois donos de cada assunto alterado aprovarem.',
      published: 'Publicado como {{id}}.',
      discard: 'Descartar',
      discardConfirm: 'Descartar este rascunho? Ele deixa de poder ser publicado.',
      discarded: 'Rascunho descartado.',
      validation: 'Validação',
      valid: 'Catálogo válido.',
      invalid: 'Corrija antes de salvar:',
      validating: 'Conferindo',
      save: 'Salvar rascunho',
      saveHelp: 'Salvar zera as aprovações já dadas.',
      savedDraft: 'Rascunho salvo.',
      reasonLabel: 'Motivo da mudança',
      subject: 'Assunto',
      ready: 'Pronto para publicar.',
      refusedState: 'Uma recusa bloqueia a publicação até o rascunho mudar.',
    },
    form: {
      id: 'Id',
      idHelp: 'Letras minúsculas, números, _ e -.',
      name: 'Nome',
      description: 'Descrição',
      synonymsHelp: 'Separe por vírgula.',
      unitHelp: 'Código de moeda (BRL), percentual ou texto (contribuintes).',
      expressionHelp: 'Na linguagem da fonte, com ao menos uma agregação. Sem $( ).',
      fieldHelp: 'Nome do campo na fonte.',
      sensitiveHelp: 'Fica fora da lista de valores e da LLM, e sai mascarado.',
      example: 'Pergunta de exemplo',
      exampleHelp: 'Sem dado pessoal: este texto vai para a LLM.',
      queryMetrics: 'Métricas (ids, separados por vírgula)',
      queryGroupBy: 'Agrupar por (ids de dimensão, separados por vírgula)',
      param: 'Parâmetro',
      paramDimension: 'Dimensão',
      paramRequired: 'Obrigatório',
      certifiedBy: 'Certificada por',
      when: 'Quando usar',
      steps: 'Passos (um por linha)',
      addMetric: 'Adicionar métrica',
      addDimension: 'Adicionar dimensão',
      addQuery: 'Adicionar query',
      addParam: 'Adicionar parâmetro',
      addPlaybook: 'Adicionar roteiro',
      editSubject: 'Editar assunto',
      apply: 'Aplicar ao rascunho',
      applied: 'Mudanças aplicadas ao rascunho. Salve para registrar.',
      fixErrors: 'Corrija os campos marcados.',
    },
  },
  apps: {
    search: 'Procurar',
    searchPlaceholder: 'Nome, id no Qlik, espaço, assunto ou cliente',
    client: 'Cliente',
    anyClient: 'Todos os clientes',
    noClient: 'Sem cliente',
    source: 'Fonte',
    accessUnavailable: 'Não deu para saber agora quais apps você abre no Qlik, então a lista ficou vazia. Tente de novo em alguns minutos.',
    emptyMine: 'Você não abre nenhum app no Qlik. Peça acesso ao administrador do Qlik.',
    anySource: 'Todas as fontes',
    sort: 'Ordem',
    sorts: {
      name: 'Nome (A a Z)',
      desc_name: 'Nome (Z a A)',
      status: 'Situação',
      client: 'Cliente',
      desc_last_reload: 'Recarga mais recente',
    },
    clear: 'Limpar filtros',
    statusFilter: 'Filtrar por situação',
    all: 'Todos',
    statusFilters: {
      published: 'Publicados',
      draft: 'Em rascunho',
      not_enabled: 'Não habilitados',
      missing: 'Sumiram da fonte',
    },
    name: 'App',
    status: 'Situação',
    version: 'Versão',
    liveVersion: 'v{{n}} no ar',
    draftVersion: 'rascunho v{{n}}',
    caption: 'Apps: {{count}}',
    select: 'Selecionar {{name}}',
    selectPage: 'Selecionar todos desta página',
    reloadedAt: 'Recarga: {{when}}',
    noMatchFor: 'Nenhum app com "{{q}}" e esses filtros.',
    noMatch: 'Nenhum app com esses filtros.',
    empty: 'Nenhum app registrado ainda. Use "Atualizar lista do Qlik" para trazer os apps que você vê no Qlik.',
    emptyOwner: 'Você ainda não é dono de nenhum app.',
    range: '{{from}} a {{to}} de {{total}}',
    perPage: 'Por página',
    prev: 'Anterior',
    next: 'Próxima',
    pageOf: 'Página {{page}} de {{pages}}',
    pagination: 'Páginas da lista',
    back: 'Voltar à lista de apps',
    unlinkOne: 'Remover {{name}} do cliente',
    bulk: {
      label: 'Ações nos apps selecionados',
      selected: 'Selecionados: {{count}}',
      setClient: 'Ligar a um cliente',
      moveClient: 'Mudar de cliente',
      unlink: 'Remover do cliente',
      enable: 'Habilitar',
      disable: 'Desligar',
      clearSelection: 'Limpar seleção',
      client: 'Cliente',
      noClient: 'Sem cliente (tirar do cliente)',
      andMore: 'e mais {{count}}',
      done: 'Pronto. Apps alterados: {{count}}.',
      partial: 'Alterados: {{changed}}. Não deu em {{failed}}:',
      set_clientTitle: 'Ligar a um cliente',
      set_clientHelp: 'Os apps passam a pertencer ao cliente escolhido. O contexto de cada um não muda.',
      set_clientConfirm: 'Ligar ({{count}})',
      set_clientNothing: 'Nenhum app selecionado.',
      unlinkTitle: 'Remover do cliente',
      unlinkHelp: 'O app continua registrado, com o contexto intacto; ele só deixa de pertencer ao cliente. O modo privacidade do cliente deixa de valer para ele.',
      unlinkConfirm: 'Remover ({{count}})',
      unlinkNothing: 'Nenhum dos selecionados tem cliente.',
      unlinkSkipped: '{{count}} já estão sem cliente e ficam como estão.',
      enableTitle: 'Habilitar apps',
      enableHelp: 'Cada app ganha um rascunho de contexto vazio, para gerar e revisar. Nada vai para os canais antes de publicar.',
      enableConfirm: 'Habilitar ({{count}})',
      enableNothing: 'Todos os selecionados já estão habilitados.',
      enableSkipped: '{{count}} já estão habilitados e ficam como estão.',
      disableTitle: 'Desligar apps',
      disableHelp: 'O rascunho aberto é descartado e a versão publicada é arquivada. O histórico fica guardado.',
      disableConfirm: 'Desligar ({{count}})',
      disableNothing: 'Nenhum dos selecionados está habilitado.',
      disableSkipped: '{{count}} já estão desligados e ficam como estão.',
      disablePublished: '{{count}} publicados saem dos canais agora.',
    },
  },
  clients: {
    title: 'Clientes',
    subtitle: 'Os apps do Qlik que você abre, com o contexto que cada um tem para o chat e os outros canais.',
    new: 'Novo cliente',
    create: 'Criar cliente',
    created: 'Cliente criado.',
    name: 'Nome',
    context: 'Contexto da empresa',
    contextHelp: 'O que o agente precisa saber da empresa em todos os apps: o que ela faz, siglas, público e regras gerais. Aceita markdown.',
    privacy: 'Modo privacidade',
    privacyHelp: 'Os números dos apps deste cliente não vão para a IA: ela sabe o que foi consultado, e os valores aparecem só para a pessoa, na tabela e no gráfico abaixo da resposta. No Claude e em outros clientes MCP, os valores não saem.',
    apps: 'Apps',
    appsCount: '{{published}} publicados de {{total}}',
    empty: 'Nenhum cliente ainda. Crie o primeiro para ligar apps a ele.',
    myApps: 'Apps',
    myAppsHelp: 'Apps cujo contexto você pode editar ou aprovar.',
    noApps: 'Nenhum app neste cliente.',
    back: 'Voltar aos clientes',
    export: 'Exportar',
    soon: 'Em breve',
    delete: 'Excluir cliente',
    deleteConfirm: 'Excluir {{name}}? Os apps dele ficam sem cliente, com o contexto intacto.',
    deleted: 'Cliente excluído.',
    tabApps: 'Apps',
    tabContext: 'Contexto da empresa',
    saved: 'Contexto da empresa salvo.',
    sync: 'Atualizar lista do Qlik',
    syncTitle: 'Atualizar lista de apps',
    syncHelp: 'Lista os apps da fonte com o seu usuário e atualiza o registro. Apps novos entram sem cliente.',
    source: 'Fonte',
    noSources: 'Nenhuma conexão configurada.',
    runSync: 'Atualizar',
    syncResult: 'Listado como {{user}}: {{added}} novos, {{updated}} atualizados, {{missing}} sumiram da fonte.',
    addApp: 'Adicionar apps',
    addAppTitle: 'Adicionar app a {{name}}',
    addAppHelp: 'Procure e marque os apps sem cliente. Se um app não aparecer, atualize a lista do Qlik.',
    noUnassigned: 'Não há apps sem cliente. Atualize a lista do Qlik.',
    titleBoth: 'Clientes e apps',
    allApps: 'Todos os apps',
    search: 'Procurar cliente',
    noMatch: 'Nenhum cliente com "{{q}}".',
    unassignedLink: 'Apps sem cliente: {{count}}',
    publishedShare: 'Publicados',
    appsAdded: 'Apps ligados ao cliente: {{count}}.',
    addApps: 'Adicionar ({{count}})',
    refineSearch: 'Aparecem os 50 primeiros de {{count}}. Refine a busca para achar o app.',
  },
  assets: {
    batteryTabs: { run: 'Rodada', answerKey: 'Gabarito', certification: 'Certificação' },
    batteryRun: {
      trendShort: '+{{improved}} −{{regressed}} desde a anterior',
      criticalShort: 'críticas {{score}}%',
      costLabel: 'Custo da rodada',
      aboutSuggestions: 'Sobre as melhorias',
      aboutBattery: 'Sobre a bateria',
      aboutLearn: 'Sobre Aprender sozinho',
      suggestionsShort: 'Melhorias ({{count}} sem decisão)',
      why: 'Por quê',
      noRuns: 'Nenhuma rodada ainda. Clique em Rodar.',
      runsCaption: 'Rodadas da bateria',
      runWhen: 'Rodada',
      runScore: 'Nota',
      runQuestions: 'Perguntas',
      runTrend: 'Mudou',
      cycleShort: 'ciclo {{cycle}}/{{cycles}}',
      backToRuns: 'Rodadas',
      runOf: 'Rodada de {{when}}',
      tokens: 'LLM: {{calls}} chamadas, {{input}} mil tokens de entrada e {{output}} mil de saída',
      validatedQuery: 'Consulta validada',
      alsoAsked: 'também perguntam',
      verified: 'verificada',
      revert: 'Desfazer',
      reverted: 'Melhoria desfeita. Rode a bateria de novo para conferir.',
      learn: 'Aprender sozinho',
      learnHelp: 'Roda a bateria, leva ao rascunho só as melhorias verificadas (fórmula igual à do gabarito) e roda de novo, até 3 ciclos ou 80%. Nada é publicado sozinho.',
      trend: '{{improved}} melhoraram · {{regressed}} pioraram desde a rodada anterior',
      cycle: 'ciclo {{cycle}} de {{cycles}}',
      trends: { melhorou: 'melhorou', piorou: 'piorou', igual: 'igual' },
      publishOne: 'Publicar esta',
      refuseOne: 'Recusar',
      publishTitle: 'Publicar esta melhoria agora?',
      publishHelp: 'Ela entra no contexto do app e vale no chat na hora. Como pula a aprovação dos donos, fica registrada na auditoria com o motivo.',
      draftHasOther: 'O app tem um rascunho aberto com outras mudanças: elas serão publicadas junto.',
      publishNow: 'Publicar agora',
      publishing: 'Publicando...',
      published: 'Melhoria publicada. Rode a bateria de novo para ver o efeito.',
      history: 'Rodada',
      historyOption: '{{when}} · nota {{score}} · {{state}}',
      ok: 'OK (mínimo {{min}}%)',
      belowMin: 'Abaixo de {{min}}%',
      newMeasure: 'Nova medida',
      synonyms: 'sinônimos',
      suggestions: 'Melhorias sugeridas ({{count}} sem decisão)',
      suggestionsHelp: 'Cada pergunta errada gera uma sugestão. As marcadas como verificadas usam a fórmula do gabarito e não precisam de revisão; as de texto, sim. Leve ao rascunho ou publique uma a uma, e rode a bateria de novo: ela testa o rascunho e mostra o que melhorou ou piorou.',
      noSuggestions: 'Nenhuma sugestão nesta rodada.',
      pickSuggestion: 'Escolher a sugestão da pergunta {{id}}',
      pickAll: 'Marcar todas sem decisão',
      toDraft: 'Levar ao rascunho ({{count}})',
      refuse: 'Recusar ({{count}})',
      applied: '{{count}} melhorias levadas ao rascunho. Rode a bateria de novo para ver o efeito.',
      draftReason: 'Melhorias sugeridas pela bateria',
      state: { aplicada: 'No rascunho', publicada: 'Publicada', recusada: 'Recusada', revertida: 'Desfeita' },
      archiveState: { concluida: 'concluída', cancelada: 'cancelada', falhou: 'falhou' },
      showQuestions: 'Ver as perguntas ({{count}})',
      noQuery: 'Não montou consulta',
      noFormulaYet: 'Ainda não perguntada',
      agentFormula: 'Fórmula do agente',
      run: 'Rodar',
      search: 'Buscar',
      searchPlaceholder: 'Pergunta, fórmula, resposta ou id',
      perPage: 'Por página',
      onlyOne: 'Mostrando só a pergunta {{id}}.',
      showAll: 'Ver todas',
      noMatch: 'Nenhuma pergunta com essa busca.',
      noAnswerYet: 'Ainda sem resposta',
      noFormula: 'gerada do catálogo',
      answered: '{{done}} de {{total}} perguntas feitas',
      tally: '{{right}} certas · {{wrong}} erradas',
      segmentsLabel: '{{right}} certas e {{wrong}} erradas de {{total}} perguntas',
      title: 'Bateria de perguntas',
      help: 'O agente recebe cada pergunta do gabarito e monta a consulta. A bateria compara a fórmula montada com a do gabarito. Nada é calculado no Qlik e nenhuma resposta em texto é guardada.',
      progress: 'Pergunta {{done}} de {{total}} ({{pct}}%)',
      progressLabel: 'Andamento da bateria',
      summary: 'Nota {{score}}%: {{right}} certas e {{wrong}} erradas. Rodada em {{when}}.',
      critical: 'Críticas: {{score}}%.',
      notRun: '{{count}} perguntas prontas. A bateria ainda não rodou com elas.',
      empty: 'Nenhuma pergunta aprovada ainda. Preencha o gabarito acima.',
      filter: 'Mostrar',
      question: 'Pergunta',
      expected: 'Fórmula esperada',
      answer: 'Resposta do agente',
      result: 'Resultado',
      criticalTag: 'crítica',
      pagination: 'Páginas das perguntas da bateria',
      filters: { all: 'Todas ({{count}})', wrong: 'Erradas ({{count}})', right: 'Certas ({{count}})', pending: 'Sem nota ainda ({{count}})' },
      results: { 'certo': 'Certa', 'errado': 'Errada', 'sem resposta': 'Sem resposta', 'não avaliado': 'Não avaliada', 'respondido': 'Respondida', 'aguardando': 'Aguardando' },
    },
    answerKey: {
      download: 'Baixar JSON',
      howTitle: 'Formato do arquivo e prompt para gerar com IA',
      formatHelp: 'O arquivo segue o formato {{format}}: data de geração (gerado_em, AAAA-MM-DD), convenções do app e a lista de testes com id, categoria, pergunta, resposta (a fórmula) e crítico. A planilha usa as mesmas colunas. O formato completo está em docs/gabarito.md.',
      privacyTitle: 'Antes de usar o prompt, combine com o cliente',
      privacy: 'A IA que monta o gabarito lê o app no Qlik: nomes de campos, valores e totais vão para o provedor dessa IA. Use só uma IA aprovada pelo cliente, com o aceite do responsável pelos dados.',
      prompt: 'Prompt para uma IA ligada ao Qlik',
      promptHelp: 'Cole numa IA que acessa o Qlik (por exemplo, por MCP). Ela devolve o JSON pronto para importar aqui.',
      copy: 'Copiar prompt',
      copied: 'Prompt copiado.',
      copyFailed: 'Não deu para copiar. Selecione o texto e copie.',
      generatedAt: 'Gabarito gerado em {{date}}',
      conventions: 'Convenções do app',
      category: 'Categoria',
      categoryN: 'Categoria da pergunta {{n}}',
      title: 'Gabarito',
      help: 'Perguntas que o agente precisa acertar e a fórmula do Qlik que responde cada uma. O valor esperado é calculado pelo Qlik, nunca digitado. Cada linha vira um caso aprovado da bateria.',
      import: 'Importar planilha ou JSON',
      paste: 'Colar JSON',
      add: 'Adicionar pergunta',
      empty: 'Sem perguntas no gabarito. Importe uma planilha com as colunas Pergunta e Resposta (a fórmula), um arquivo JSON, ou adicione à mão.',
      question: 'Pergunta',
      formula: 'Resposta (fórmula do Qlik)',
      critical: 'Crítica',
      questionN: 'Pergunta {{n}}',
      formulaN: 'Fórmula da pergunta {{n}}',
      criticalN: 'Pergunta {{n}} é crítica',
      removeN: 'Tirar a pergunta {{n}}',
      pagination: 'Páginas do gabarito',
      saved: 'Gabarito salvo com {{count}} perguntas. As fórmulas novas foram calculadas no Qlik.',
      saving: 'Salvando e calculando no Qlik...',
      count: '{{count}} perguntas',
      incomplete: '{{count}} linhas sem pergunta ou sem fórmula não serão salvas',
      loaded: '{{count}} perguntas carregadas. Confira e salve.',
      warnings: '{{count}} linhas ignoradas',
      pasteTitle: 'Colar o gabarito em JSON',
      pasteHelp: 'Uma lista de objetos com pergunta e resposta (a fórmula). Também vale "formula" no lugar de "resposta" e "critico": true.',
      pasteLoad: 'Carregar',
    },
    name: 'App',
    space: 'Espaço',
    status: 'Estado',
    published: 'Publicada',
    draft: 'Rascunho',
    lastReload: 'Última recarga',
    missing: 'Sumiu da fonte',
    missingHelp: 'A última atualização da lista não encontrou este app na fonte: ele foi apagado ou quem atualizou perdeu o acesso.',
    statuses: { nao_habilitado: 'Não habilitado', rascunho: 'Rascunho', publicado: 'Publicado' },
    versionN: 'v{{n}}',
    qlikId: 'Id no Qlik',
    client: 'Cliente',
    noClient: 'Sem cliente',
    publishedVersion: 'Versão publicada',
    publish: 'Publicar',
    saveFirst: 'Salve as alterações antes de publicar.',
    publishedOk: 'Versão {{n}} publicada.',
    editContext: 'Editar contexto',
    newDraftTitle: 'Abrir rascunho',
    newDraftHelp: 'O rascunho começa da versão publicada, ou vazio se nada foi publicado. O motivo aparece no histórico.',
    newDraftFrom: 'O rascunho começa da versão {{n}}. O motivo aparece no histórico.',
    reason: 'Motivo',
    create: 'Abrir rascunho',
    draftCreated: 'Rascunho v{{n}} aberto.',
    draftExists: 'Já existe um rascunho aberto. Publique ou descarte antes.',
    disable: 'Desligar app',
    disableConfirm: 'Desligar {{name}}? O app sai do catálogo e o chat deixa de responder por ele. O contexto continua guardado.',
    disabled: 'App desligado.',
    generate: {
      againTitle: 'Gerar o contexto de novo',
      againHelp: 'Lê o app no Qlik outra vez, leva alguns minutos e cria uma proposta nova para revisar. O contexto publicado não muda até alguém aceitar a proposta, aprovar e publicar.',
      notes: 'O que você sabe sobre este app',
      notesHelp: 'A geração lê o app no Qlik com o seu acesso. Se quiser, conte antes o que só quem conhece o app sabe.',
      notesHint: 'Siglas, regras de negócio, o que fica de fora, quais números importam. A IA usa isso para escrever o significado de cada item; se a nota não bater com a fórmula, ela avisa e pergunta.',
      images: 'Imagens',
      imagesHint: 'Até {{count}} prints de tela ou fotos de documento. Também dá para colar um print no campo de texto com Ctrl+V.',
      imagesMax: 'Cabem até {{count}} imagens.',
      imageUnreadable: 'Não deu para ler essa imagem. Use PNG, JPEG ou WebP.',
      imageN: 'Imagem {{n}}',
      imageRemove: 'Tirar a imagem {{n}}',
      title: 'Gerar contexto',
      help: 'O Lastrouter lê o modelo do app no Qlik como você (tabelas, campos, medidas e dimensões mestras, pastas) e monta uma proposta de contexto com os riscos que encontrou. Nada entra no app até você aplicar a proposta num rascunho.',
      start: 'Gerar contexto',
      none: 'Nenhuma geração ainda.',
      runs: 'Gerações',
      runsHint: 'As outras abas mostram a geração escolhida aqui.',
      run: 'Geração',
      startedBy: 'Iniciada por {{user}} em {{when}}',
      modelCounts: '{{tables}} tabelas, {{fields}} campos, {{measures}} medidas e {{dimensions}} dimensões mestras, {{sheets}} pastas',
      steps: {
        ler_modelo: 'Ler o modelo no Qlik',
        extrair: 'Ler o app no Qlik',
        planejar: 'Planejar as checagens',
        calcular: 'Calcular na engine do Qlik',
        interpretar: 'Interpretar com IA',
        gerar: 'Montar contexto e proposta',
        gravar: 'Guardar',
        bateria: 'Bateria contra o agente'
      },
      cancel: 'Cancelar',
      cancelled: 'Cancelado. O que já tinha sido gravado fica na execução.',
      cancelledTitle: 'Execução cancelada',
      runningHint: 'A tela se atualiza sozinha. Pode sair daqui: a geração continua no servidor.',
      errorTitle: {
        ler_modelo: 'Não deu para ler o app no Qlik',
        extrair: 'Não deu para ler o app no Qlik',
        planejar: 'Não deu para planejar as checagens',
        calcular: 'A engine do Qlik não calculou as checagens',
        interpretar: 'A IA não conseguiu interpretar o app',
        gerar: 'Não deu para montar o contexto',
        bateria: 'A bateria contra o agente parou no meio',
        other: 'A geração parou com erro'
      },
      errorHelp: 'Confira se você abre este app no Qlik e tente de novo. Se repetir, mande o texto abaixo para o suporte.',
      stepStatus: {
        rodando: 'Rodando',
        ok: 'Feito',
        falhou: 'Falhou'
      },
      runStatus: {
        rodando: 'rodando',
        ok: 'pronta',
        falhou: 'falhou',
        interrompida: 'interrompida'
      },
      findings: 'Riscos encontrados ({{n}})',
      findingsHelp: 'Os críticos e altos viram regras na seção Restrições da proposta.',
      noFindings: 'Nenhum risco encontrado no modelo.',
      severity: {
        critico: 'Crítico',
        alto: 'Alto',
        medio: 'Médio',
        baixo: 'Baixo'
      },
      impact: 'Impacto',
      recommendation: 'O que fazer',
      risk: {
        accept: 'Aceitar risco',
        accepted: 'Aceito',
        acceptedBy: 'Aceito por {{by}} em {{when}}: {{reason}}',
        reason: 'Motivo do aceite',
        reasonHint: 'Pelo menos 10 caracteres. Ex.: tabela de seletor, solta de propósito.',
        confirm: 'Aceitar',
        reopen: 'Reabrir',
        acceptedToast: 'Risco aceito. Certificação refeita.',
        reopenedToast: 'Risco reaberto. Certificação refeita.'
      },
      applied: 'Proposta aplicada ao rascunho. As aprovações foram zeradas.',
      startAgain: 'Gerar de novo',
      pipeline: {
        resultTitle: 'Resultado',
        resultHelp: 'O que o Lastrouter achou no app e o que propõe. Os números saem da engine do Qlik.',
        risks: 'Riscos por gravidade',
        riskCount_one: '{{count}} risco',
        riskCount_other: '{{count}} riscos',
        questions: 'Perguntas para o cliente',
        questionsHint: 'respondidas na planilha',
        ofTotal: '{{n}} de {{total}}',
        catalog: 'Catálogo recomendado',
        catalogHint: 'itens do app que o agente deve usar, revisar ou não ver',
        expose: 'mostrar',
        review: 'revisar',
        hide: 'esconder',
        quality: 'Qualidade do catálogo',
        qualityHint: 'hoje → com o contexto proposto',
        numbers: 'Situação dos números',
        numbersHint: 'conferência dos totais na engine',
        ai: 'IA usada',
        aiDetail: '{{items}} itens interpretados, {{removed_evidence}} evidências sem prova removidas, {{rewrites}} descrições reescritas',
        noAi: 'Sem IA configurada: o contexto saiu sem o significado escrito dos itens.',
        noData: 'sem dado',
        outOfProposal: 'Itens que ficaram fora da proposta ({{n}})',
        outOfProposalHelp: 'Aparecem no app, mas o Lastrouter não conseguiu levar para o contexto. Trate à mão se precisar.',
        downloadTitle: 'Baixar',
        downloadHelp: 'A planilha vai para o cliente. Os outros arquivos são o contexto em outros formatos.',
        files: {
          checkpoint_xlsx: 'Planilha do cliente',
          contexto_ossie_yaml: 'Contexto no formato Ossie',
          vocabulario_qlik_answers_xlsx: 'Vocabulário do Qlik Answers',
          contexto_json: 'Contexto (JSON)',
          avaliacao_json: 'Baixar a avaliação',
          bateria_json: 'Bateria (JSON)',
          snapshot_json: 'Leitura do app (JSON)'
        },
        validationTitle: 'Validação do cliente',
        validationHelp: 'Baixe a planilha do cliente, ele aprova os casos de teste, responde as perguntas, decide o catálogo e marca os riscos, e você envia o arquivo preenchido aqui.',
        file: 'Planilha preenchida (.xlsx, até 10 MB)',
        send: 'Enviar planilha preenchida',
        sending: 'Enviando...',
        sent: 'Planilha importada. Contexto, bateria e certificação foram refeitos.',
        tooBig: 'O arquivo passa de 10 MB. Envie só a planilha preenchida.',
        changedTitle: 'O que mudou com a planilha',
        changedCases: 'Casos aprovados: {{before}} → {{after}}',
        changedAnswers: 'Perguntas respondidas: {{before}} → {{after}} de {{total}}',
        batteryTitle: 'Bateria e certificação',
        batteryHelp: 'A bateria faz ao agente as perguntas do gabarito, cada uma numa conversa nova, e compara a fórmula que ele monta com a do gabarito.',
        batteryCounts: '{{cases}} perguntas na bateria, {{critical}} críticas, {{approved}} prontas.',
        runBattery: 'Rodar bateria contra o agente',
        noApproved: 'Ainda não há caso aprovado. O cliente aprova os casos na aba Bateria da planilha; envie a planilha de volta e o botão libera.',
        batteryRunning: 'Bateria rodando. Leva alguns minutos e a tela se atualiza sozinha.',
        released: 'Liberado para produção',
        blocked: 'Certificação incompleta (não impede publicar)',
        contextVersion: 'contexto {{v}}',
        score: 'Nota geral',
        criticalScore: 'Nota dos casos críticos',
        noScore: 'As notas aparecem depois da primeira bateria contra o agente.',
        conditionOk: 'cumprida',
        conditionNo: 'não cumprida'
      }
    },
    tabsLabel: 'Etapas do contexto do app',
    tabs: { summary: 'Resumo', risks: 'Riscos', context: 'Contexto', validation: 'Validação', battery: 'Bateria', publish: 'Publicar', quality: 'Qualidade', versions: 'Versões' },
    tabState: { done: 'feito', pending: 'pendente', blocked: 'bloqueado' },
    nextStepTo: 'Próximo passo: {{tab}}',
    nextHint: {
      summary: 'Gere o contexto: o Lastrouter lê o app no Qlik e monta uma proposta.',
      risks: 'Veja os riscos que a geração encontrou no modelo do app.',
      context: 'Compare a proposta com o que vale hoje, seção por seção, e leve para o rascunho o que fizer sentido.',
      validation: 'Baixe a planilha, mande ao cliente e envie de volta preenchida.',
      battery: 'Rode a bateria contra o agente para tirar o selo de liberado.',
      publish: 'Publique com a aprovação dos donos, ou direto, com motivo registrado.',
      versions: 'Veja as versões publicadas e o que mudou em cada uma.',
    },
    goTo: 'Abrir {{tab}}',
    needsRun: {
      none: 'Esta etapa usa a geração do contexto, que ainda não rodou neste app.',
      unfinished: 'A última geração não terminou. Veja a situação no Resumo.',
      old: 'Esta geração é do formato antigo, sem bateria. Gere de novo para ter esta etapa.',
    },
    review: {
      openAll: 'Abrir todas',
      closeAll: 'Fechar todas',
      today: 'O que vale hoje',
      proposal: 'Proposta da geração',
      draft: 'Texto novo',
      whatChanges: 'O que muda',
      diff: { add: 'entra', del: 'sai' },
      emptyText: 'Vazio.',
      tag: { suggested: 'Proposta nova', changed: 'Mudou no rascunho', same: 'Sem proposta' },
      accept: 'Aceitar a proposta',
      edit: 'Editar',
      keep: 'Manter o de hoje',
      runSuggests: 'Ver o texto que a geração propõe',
      fromRun: 'Proposta da geração de {{when}}, por {{user}}',
      pending_one: '{{count}} parte com proposta para revisar.',
      pending_other: '{{count}} partes com proposta para revisar.',
      nothingPending: 'Tudo o que a geração propôs já está no contexto.',
      acceptAll: 'Aceitar todas as propostas',
      saveFirst: 'Salve as alterações do rascunho antes de aceitar uma proposta.',
      draftReason: 'Proposta da geração de contexto',
      semanticHelp: 'Métricas, dimensões, consultas validadas e roteiros que o agente usa para consultar o Qlik.',
      semanticCounts: '{{metrics}} métricas e {{dimensions}} dimensões',
      semanticFresh_one: 'A geração propõe {{count}} item que o app ainda não tem: {{names}}.',
      semanticFresh_other: 'A geração propõe {{count}} itens que o app ainda não tem: {{names}}.',
      semanticNoFresh: 'O app já tem todas as métricas e dimensões da proposta.',
      addMissing: 'Acrescentar o que falta',
      replaceAll: 'Substituir pela proposta',
      editSemantic: 'Editar métricas, dimensões e consultas',
      seeSemantic: 'Ver métricas, dimensões e consultas',
    },
    semantic: 'Camada semântica',
    versions: 'Versões',
    history: 'Histórico',
    sections: {
      contexto: 'Contexto',
      regras: 'Regras de negócio',
      premissas: 'Premissas',
      restricoes: 'Restrições e negativos',
      vocabulario: 'Vocabulário',
      sinonimos: 'Sinônimos',
      exemplos: 'Exemplos e contexto adicional',
      correcoes: 'Correções',
      tom: 'Tom de voz',
    },
    sectionHelp: {
      contexto: 'O que o app cobre, de onde vêm os dados e para quem ele serve.',
      regras: 'Como calcular e interpretar os números deste app.',
      premissas: 'O que o agente pode assumir quando a pergunta não diz, como período padrão ou unidade.',
      restricoes: 'O que o agente não pode fazer ou responder. É obrigatório seguir.',
      vocabulario: 'Siglas e termos do negócio, com o significado de cada um.',
      sinonimos: 'Outros nomes que as pessoas usam para métricas, dimensões e valores.',
      exemplos: 'Perguntas de exemplo e contexto que ajuda a responder.',
      correcoes: 'Correções feitas por pessoas. Valem mais que as regras.',
      tom: 'Como o assistente fala sobre este app: formal ou próximo, termos a evitar, como tratar a pessoa. Vale por cima do tom geral da Aparência.',
    },
    noDraft: 'Você vê a versão publicada. Para mudar, clique em Editar na seção, escreva e salve. A mudança fica guardada à parte e só chega ao chat depois de aprovada e publicada.',
    nothing: 'Este app ainda não está habilitado. Habilite na lista de apps para gerar e editar o contexto.',
    saveReason: 'Motivo da mudança',
    saveHelp: 'Salvar grava o rascunho inteiro e zera as aprovações já dadas.',
    saved: 'Rascunho salvo.',
    stale: 'Outra pessoa salvou este rascunho antes de você. Recarregue para ver a versão atual; as suas alterações locais serão perdidas.',
    reload: 'Recarregar',
    issues: 'O que impede publicar',
    approvals: 'Aprovações do rascunho v{{n}}',
    approvalsHelp: 'O rascunho precisa da aprovação do dono de negócio e do dono técnico.',
    discard: 'Descartar rascunho',
    discardConfirm: 'Descartar o rascunho v{{n}}? Ele deixa de poder ser publicado.',
    discarded: 'Rascunho descartado.',
    noVersions: 'Nenhuma versão ainda.',
    openFrom: 'Abrir rascunho a partir desta versão',
    versionsTable: { number: 'Versão', state: 'Estado', by: 'Por', when: 'Quando', reason: 'Motivo e mudanças' },
    states: { rascunho: 'Rascunho', publicada: 'Publicada', arquivada: 'Arquivada', descartada: 'Descartada' },
    changes: {
      when: 'Quando',
      who: 'Quem',
      part: 'Parte',
      operation: 'Operação',
      reason: 'Motivo',
      before: 'Antes',
      after: 'Depois',
      show: 'Ver o texto',
      empty: 'Nenhuma alteração registrada.',
    },
    operations: { add: 'Inclusão', replace: 'Alteração', remove: 'Remoção' },
    changeClient: 'Trocar cliente',
    setClient: 'Ligar a um cliente',
    changeClientHelp: 'O app passa para o cliente escolhido; o contexto não muda.',
    clientRemoved: 'App removido do cliente.',
    clientChanged: 'Cliente do app alterado.',
    unlinkConfirm: 'Remover {{app}} de {{client}}?',
    unvalidated: {
      noticeBy: 'Por {{by}} em {{when}}.',
      reason: 'Motivo',
      reasonHint: 'Pelo menos 10 caracteres. O motivo fica na versão, no alerta e na auditoria.',
      pendingTitle_one: '{{count}} pendência',
      pendingTitle_other: '{{count}} pendências',
      dialogTitle: 'Publicar a versão {{n}} direto',
      dialogHelp: 'O contexto vai para os agentes agora. As aprovações que faltam ficam no seu nome, no lugar dos donos, e o motivo fica na auditoria.',
      confirm: 'Publicar direto',
      open: 'Publicar direto...',
      done: 'Versão {{n}} publicada.',
      title: 'Publicar direto',
      help: 'Atalho do admin para quando os donos não podem aprovar agora. Pede motivo e fica na auditoria.',
      normalTitle: 'Publicar com aprovação',
      normalHelp: 'O caminho normal: os dois donos aprovam o rascunho e o admin publica.',
      ownerPending: {
        negocio: 'Falta a aprovação do dono de negócio ({{owner}}).',
        tecnico: 'Falta a aprovação do dono técnico ({{owner}}).',
      },
      adminOnly: 'Só o administrador publica.',
      nothingPending: 'Nada pendente. Use Publicar.',
      refused: '{{who}} recusou esta versão. Edite o rascunho ou peça uma nova decisão: o atalho não passa por cima da recusa.',
      nothingToPublish: 'A versão {{n}} está publicada e não há mudança esperando. Para mudar o contexto, edite na aba Contexto e salve.',
    },
  },
  users: {
    title: 'Usuários',
    subtitle: 'Quem usa o Lastrouter e com qual papel. Os papéis ficam no Entra ID e esta tela muda o Entra direto, sem passar pelo portal da Azure. Os apps que cada pessoa vê vêm do Qlik.',
    addButton: 'Dar acesso a uma pessoa',
    giveAccess: 'Dar acesso',
    search: 'Buscar',
    searchPlaceholder: 'Nome ou e-mail',
    roleFilter: 'Papel',
    noRole: 'Sem papel',
    caption: '{{count}} pessoas',
    person: 'Pessoa',
    role: 'Papel no Entra',
    qlikUser: 'Usuário no Qlik',
    lastSeen: 'Último acesso',
    never: 'Nunca usou',
    you: 'você',
    group: 'Grupo',
    origin: { entra: 'Atribuído no Entra', audit: 'Só na auditoria' },
    roles: { reader: 'Leitor', editor: 'Editor', admin: 'Admin' },
    roleHelp: { reader: 'faz consultas dinâmicas e analisa', editor: 'também propõe correção de contexto pelo chat', admin: 'também usa o painel' },
    roleOf: 'Papel de {{name}}',
    changed: '{{name}} agora é {{role}}.',
    selfLock: 'Você não pode tirar o seu próprio papel de Admin. Peça a outro administrador.',
    empty: 'Ninguém com papel no Entra nem na auditoria dos últimos 90 dias.',
    noMatch: 'Ninguém com esse nome ou papel.',
    graph: {
      not_configured: 'O painel não está ligado ao Entra',
      forbidden: 'O Lastrouter ainda não tem permissão para mudar papéis no Entra',
      error: 'O Entra não respondeu',
      not_connected: 'Conecte a sua conta para ver e mudar os papéis do Entra',
      connect: 'Conectar ao Entra',
      ok: '',
      steps: 'Até lá, a lista mostra quem aparece na auditoria, e incluir, trocar ou remover papel fica desligado.',
    },
    add: {
      title: 'Dar acesso a uma pessoa',
      help: 'Busque a pessoa no diretório do Entra e escolha o papel. A mudança vale no próximo login dela.',
      role: 'Papel',
      search: 'Nome ou e-mail',
      searchPlaceholder: 'maria ou maria@empresa.com',
      searchButton: 'Buscar',
      noResults: 'Ninguém encontrado no diretório.',
      give: 'Dar acesso como {{role}}',
      done: '{{name}} recebeu o papel {{role}}.',
    },
    remove: {
      button: 'Remover acesso',
      aria: 'Remover o acesso de {{name}}',
      title: 'Remover o acesso de {{name}}?',
      help: 'A pessoa perde os papéis do Lastrouter no Entra e deixa de usar o chat, o Teams e o painel no próximo login. Dá para dar acesso de novo depois.',
      confirm: 'Remover acesso',
      done: '{{name}} não tem mais acesso.',
    },
  },
  access: {
    title: 'Acesso',
    subtitle: 'Os papéis do IdP dizem o que a pessoa pode fazer: Leitor faz consultas dinâmicas, Editor também corrige o contexto pelo chat, Admin usa o painel. Os apps que ela vê vêm do Qlik.',
    subject: 'Assunto',
    source: 'Fonte',
    owners: 'Donos',
    simTitle: 'Simular uma pessoa',
    simHelp: 'Mostra as ferramentas que estes papéis liberam e os apps que a pessoa enxerga no Qlik. Lista os apps como ela, sem consultar dados.',
    upn: 'Login (UPN)',
    roles: 'Papéis (um por linha)',
    clientApp: 'App cliente (client id)',
    simulate: 'Simular',
    channel: 'Canal',
    refused: 'Recusado: {{reason}}',
    tools: 'Ferramentas',
    subjects: 'Assuntos',
    sourceUser: 'Usuário na fonte',
  },
  people: {
    title: 'Pessoas',
    subtitle: 'Quem usa o Lastrouter, com qual papel e com qual limite.',
    tabUsers: 'Usuários',
    tabLimits: 'Limites por pessoa',
    tabSimulate: 'Simular acesso',
  },
  products: {
    status: 'Situação',
    configured: 'Configurado',
    notConfigured: 'Não configurado',
    fromFile: 'Hoje valem as configurações do arquivo (lastrouter.yaml). Ao salvar uma mudança aqui, o painel passa a valer para todos os canais, começando por uma cópia do arquivo.',
    fromPanel: 'As configurações dos canais estão salvas no painel e valem por cima do arquivo.',
    backToFile: 'Voltar a usar o arquivo',
    backToFileHelp: 'As configurações salvas no painel para todos os canais deixam de valer, e voltam as do arquivo de configuração. Os limites por canal continuam.',
    savedFile: 'Voltou a valer o arquivo de configuração.',
    saved: 'Configurações do canal salvas.',
    channelHelp: 'O que este canal pode fazer com o contexto. Muda na hora, sem reiniciar.',
    staging: 'Homologação',
    tools: 'O que o canal pode fazer',
    toolsHelp: 'Menos opções deixam as respostas mais certeiras.',
    toolsRequired: 'Escolha pelo menos uma.',
    limit: 'Consultas por minuto, por pessoa',
    limitHelp: 'Vazio: vale {{n}} por minuto.',
    limitHelpFile: 'Vazio: vale o limite geral, em Configurações.',
    privateValues: 'Mostra os valores na tela da pessoa',
    privateValuesHelp: 'Para clientes em modo privacidade. Ligado, o canal mostra os números só para quem perguntou, e a IA não os vê. Desligado, o canal recebe a resposta sem os valores. Ligue só no Chat e no Ask no Teams, que sabem esconder os números da IA.',
    advanced: 'Avançado',
    channelId: 'Id do canal',
    channelIdHelp: 'Nome curto, em minúsculas, que aparece na Auditoria e nas Conversas.',
    idError: 'Use letras minúsculas, números, - ou _, sem repetir outro canal.',
    clientIds: 'Ids dos apps cliente no Entra (um por linha)',
    clientIdsHelp: 'O id do aplicativo (client id) com que o agente entra. Vazio: só o próprio Lastrouter usa este canal.',
    removeConnector: 'Remover conector',
    removeConnectorHelp: '{{name}} deixa de usar o Lastrouter. Os outros canais não mudam.',
    noChannel: 'Este canal ainda não tem configuração (id "{{id}}"). Sem ela, ele não consegue usar o Lastrouter.',
    createChannel: 'Configurar',
    copy: 'Copiar',
    copied: 'Copiado.',
    teams: {
      title: 'Ask no Teams',
      subtitle: 'O Ask, assistente de dados que usa o contexto do Lastrouter, dentro do Microsoft Teams.',
      channel: 'Configuração no Lastrouter',
      lastQuestion: 'Última consulta dinâmica pelo Teams',
      noQuestion: 'Nenhuma nos últimos dias',
      package: 'Pacote do app',
      packageHelp: 'A versão fica no pacote (zip) do app do Teams, gerado pela equipe da Cluster. Esta tela ainda não lê a versão.',
      installTitle: 'Como instalar no Teams',
      install1: 'Peça à equipe da Cluster o pacote do app do Teams (arquivo .zip).',
      install2: 'No Teams admin center, em Aplicativos do Teams > Gerenciar aplicativos, envie o pacote ou atualize o app que já existe.',
      install3: 'Libere o app para quem vai usar e confira com uma consulta dinâmica de teste.',
      channelTitle: 'Configurações do Ask no Teams',
    },
    chat: {
      title: 'Chat',
      subtitle: 'O chat do Lastrouter no navegador, para testar o contexto ou usar no dia a dia.',
      open: 'Abrir o chat',
      address: 'Endereço',
      login: 'Login pelo Entra',
      help: 'Quem tem papel no Lastrouter entra com a conta da organização e vê os apps que vê no Qlik.',
      off: 'O chat ainda não está ligado: falta a seção chat no arquivo de configuração. Fale com a TI.',
      channelTitle: 'Configurações do Chat',
    },
    mcp: {
      title: 'Conectores MCP',
      subtitle: 'Claude, Copilot e outros agentes usando o contexto do Lastrouter pelo protocolo MCP.',
      add: 'Adicionar conector',
      connectTitle: 'Como conectar',
      address: 'Endereço do MCP',
      claude1: 'No Claude, abra Configurações > Conectores e escolha adicionar um conector personalizado.',
      claude2: 'Cole o endereço do MCP acima.',
      claude3: 'Entre com a conta da organização quando o Claude pedir.',
      copilot1: 'No Copilot Studio, abra o agente e vá em Ferramentas > Adicionar ferramenta > Model Context Protocol.',
      copilot2: 'Cole o endereço do MCP e escolha o login OAuth com o Entra.',
      copilot3: 'Adicione aqui um conector com o id do aplicativo do Copilot, em Avançado.',
      newConnector: 'Novo conector',
      empty: 'Nenhum conector. Use "Adicionar conector" para liberar o Claude, o Copilot ou outro agente.',
      kinds: {
        claude: 'Claude ({{id}})',
        copilot: 'Copilot ({{id}})',
        other: 'Outro conector ({{id}})',
      },
    },
  },
  limits: {
    subtitle: 'Consultas por minuto que cada pessoa pode fazer. Cada canal e cada pessoa podem ter o seu limite; vale na hora, sem reiniciar.',
    global: 'Limite geral por pessoa',
    globalHelp: 'Vazio: vale o do arquivo de configuração.',
    perUser: 'Exceções por pessoa',
    perUserHelp: 'Para quem precisa de um limite diferente do padrão. Vale na hora.',
    limit: 'Consultas por minuto',
    user: 'Login',
    addUser: 'Adicionar exceção',
    noUsers: 'Nenhuma exceção.',
    saved: 'Limites salvos.',
    invalid: 'Use um número inteiro de 1 a 10.000.',
  },
  quality: {
    title: 'Qualidade',
    subtitle: 'Como o agente está respondendo, por assunto e por semana.',
    tabWeekly: 'Taxa de resposta',
    tabFeedback: 'Feedback',
    tabProposals: 'Propostas',
    tabCandidates: 'Perguntas para a suíte',
    tabReports: 'Resultados da suíte',
    chartTitle: 'Taxa de resposta por semana',
    chartHelp: 'Parcela das consultas dinâmicas respondidas sem pedir esclarecimento. Semanas com o marcador caíram mais de 10 pontos e pedem revisão com o dono do assunto.',
    showTable: 'Ver tabela',
    showChart: 'Ver gráfico',
    week: 'Semana',
    subject: 'Assunto',
    questions: 'Consultas dinâmicas',
    answered: 'Respondidas',
    clarifications: 'Esclarecimentos',
    noAnswer: 'Sem resposta',
    errors: 'Erros',
    negative: 'Feedback negativo',
    rate: 'Taxa de resposta',
    review: 'Revisar',
    noSubject: 'Sem assunto',
    noData: 'Ainda não há consultas dinâmicas registradas.',
    feedback: {
      when: 'Quando',
      kind: 'Tipo',
      comment: 'Comentário',
      query: 'Query',
      state: 'Estado',
      routed: 'Encaminhado para',
      kinds: { wrong: 'Resposta errada', review: 'Pedido de revisão', useful: 'Útil' },
      states: { aberto: 'Aberto', em_revisao: 'Em revisão', resolvido: 'Resolvido', descartado: 'Descartado' },
      change: 'Mudar estado',
      resolution: 'Resolução',
      empty: 'Nenhum feedback com este filtro.',
      saved: 'Estado atualizado.',
    },
    proposals: {
      generate: 'Gerar propostas',
      generated: 'Propostas geradas: {{count}}.',
      kinds: { sinonimo: 'Sinônimo', exemplo: 'Exemplo', nova_query: 'Query nova', revisao: 'Revisão' },
      states: { proposta: 'Proposta', aceita: 'Aceita', recusada: 'Recusada' },
      accept: 'Aceitar',
      refuse: 'Recusar',
      evidence: 'Evidência',
      acceptHelp: 'Aceitar não muda o catálogo: abra um rascunho com a mudança.',
      empty: 'Nenhuma proposta. Gere a partir das conversas com problema.',
    },
    candidates: {
      question: 'Pergunta',
      reason: 'Por quê',
      empty: 'Nenhuma pergunta candidata.',
      help: 'Perguntas reais sem resposta ou com feedback negativo. Leve as relevantes para perguntas.yaml com a resposta certa por usuário.',
    },
    reports: {
      label: 'Rodada',
      when: 'Quando',
      answerRate: 'Resposta',
      accuracy: 'Acerto',
      certifiedWrong: 'Certificadas erradas',
      deterministic: 'Determinística',
      open: 'Abrir relatório',
      empty: 'Nenhum resultado da suíte ainda. Rode lastrouter eval.',
    },
  },
  channels: {
    toolNames: {
      search_context: 'Buscar no contexto',
      list_values: 'Listar valores de um campo',
      run_validated_query: 'Rodar consulta validada',
      explain_result: 'Explicar um resultado',
      resolve_question: 'Entender a consulta',
      report_feedback: 'Registrar o retorno da pessoa',
      query_metric: 'Consultar métrica',
      list_apps: 'Listar os apps',
      describe_app: 'Descrever um app',
      query: 'Consultar dados',
      propose_context_change: 'Propor correção de contexto',
    },
  },
  conversations: {
    find: 'Procurar nas conversas',
    findPlaceholder: 'Consulta, resposta ou pessoa',
    noMatch: 'Nenhuma conversa com "{{q}}" entre as carregadas.',
    title: 'Conversas',
    subtitle: 'As consultas dinâmicas que as pessoas fizeram, como foram respondidas e o retorno delas. Valores dos resultados não ficam aqui.',
    defaultPeriod: 'Sem data, mostra os últimos 7 dias.',
    question: 'Consulta dinâmica',
    answer: 'Resposta',
    feedback: 'Retorno',
    useful: 'Útil',
    wrong: 'Errado',
    noFeedback: 'Sem retorno',
    ok: 'Respondida',
    detail: 'Conversa',
    noQuestion: 'A consulta não veio na chamada.',
    auditOnly: 'Este canal não tem bot próprio: o Lastrouter vê as chamadas de ferramenta, não o texto da resposta.',
    auditShort: 'Texto da resposta fica no cliente',
    model: 'Modelo',
    rounds: 'Rodadas da LLM',
    tokens: 'Tokens da LLM',
    tokensValue: '{{input}} de entrada ({{cached}} do cache), {{output}} de saída, em {{calls}} chamadas',
    unverified: 'Números sem fonte',
    steps: 'Passos',
    noSteps: 'Nenhuma ferramenta chamada.',
    results: 'Resultados mostrados',
    resultsGone: '{{count}} resultado(s) fora da retenção ou de app que você não vê.',
    filters: 'Filtros',
    noFilters: 'nenhum',
    except: 'exceto',
    range: 'de {{from}} até {{to}}',
    certified: 'Certificado',
    notCertified: 'Não certificado',
    executedAt: 'Calculado em',
    caveats: 'Avisos',
    replay: 'Refazer a consulta',
    empty: 'Nenhuma conversa com estes filtros.',
    shown: '{{count}} conversa(s)',
    truncated: 'Mostrando as {{count}} mais recentes. Encurte o período para ver as outras.',
  },
  audit: {
    title: 'Auditoria',
    subtitle: 'Uma linha por chamada de ferramenta, com a expressão executada. Sem valores de resultado.',
    from: 'De',
    to: 'Até',
    user: 'Usuário',
    tool: 'Ferramenta',
    status: 'Estado',
    subject: 'Assunto',
    any: 'Todos',
    filter: 'Filtrar',
    clear: 'Limpar',
    when: 'Quando',
    channel: 'Canal',
    query: 'Query',
    rows: 'Linhas',
    duration: 'Duração',
    statuses: { ok: 'Respondida', clarification: 'Esclarecimento', no_answer: 'Sem resposta', error: 'Erro' },
    beforeTool: 'Recusada antes da ferramenta',
    loadMore: 'Carregar mais',
    export: 'Exportar CSV',
    verify: 'Conferir corrente de hash',
    chainOk: 'Corrente íntegra: {{records}} linhas em {{files}} arquivo(s).',
    chainBroken: 'Corrente quebrada em {{file}}, linha {{line}}: {{reason}}',
    detail: 'Linha de auditoria',
    empty: 'Nenhuma linha com estes filtros.',
    shown: '{{count}} linha(s) na tela',
    expressions: 'Expressões executadas',
    publication: 'Publicação do catálogo',
    promptModel: 'Prompt e modelo',
    versions: 'Versões',
    lastReload: 'Última recarga do app',
    tokens: 'Tokens (entrada / saída)',
    result: 'Resultado',
    hash: 'Hash da corrente',
  },
  appearance: {
    title: 'Aparência',
    subtitle: 'Só a camada de marca muda: nome do assistente, tom de voz, cor de destaque, logo e ícone. Estrutura e tipografia são da Cluster.',
    name: 'Nome do assistente',
    voice: 'Tom de voz',
    voiceHelp: 'Como o assistente fala em todos os canais e apps. Um app com a seção Tom de voz no contexto usa o dele.',
    voicePlaceholder: 'Ex.: formal e direto, trate por você, sem gírias, explique siglas na primeira vez.',
    color: 'Cor de destaque',
    colorHelp: 'Precisa de 4,5:1 com texto branco e 3:1 sobre o fundo escuro.',
    onWhite: 'Texto branco sobre a cor: {{ratio}}:1',
    onDark: 'Cor sobre o fundo escuro: {{ratio}}:1',
    passes: 'Contraste aprovado.',
    fails: 'Esta cor não passa no contraste. Escolha uma mais escura.',
    invalidColor: 'Use o formato #RRGGBB.',
    logo: 'Logo',
    icon: 'Ícone',
    upload: 'Enviar imagem',
    removeImage: 'Remover',
    imageHelp: 'PNG, JPEG ou WebP até 200 KB.',
    tooLarge: 'A imagem passa de 200 KB.',
    wrongType: 'Use PNG, JPEG ou WebP.',
    preview: 'Prévia de uma resposta',
    previewQuestion: 'Quanto Porto Alegre arrecadou em setembro do ano passado?',
    previewAnswer: 'R$ 1.234.567,89 em setembro de 2025, Porto Alegre',
    certified: 'Certificado',
    useful: 'Útil',
    wrong: 'Errado',
    askReview: 'Pedir revisão',
    saved: 'Aparência salva.',
  },
  settings: {
    title: 'Configurações',
    subtitle: 'Limite geral de uso e informações do sistema. O arquivo de configuração vem do lastrouter.yaml e só a TI muda.',
    version: 'Versão',
    edition: 'Edição',
    instance: 'Instância',
    tenant: 'Tenant',
    backend: 'Estado guardado em',
    uptime: 'No ar há',
    license: 'Licença',
    customer: 'Cliente',
    validity: 'Validade',
    features: 'Recursos',
    lastCheckin: 'Último check-in',
    config: 'Arquivo de configuração (sem segredos)',
    editions: { selfhosted: 'Self-hosted', cloud: 'Cloud' },
    backends: { files: 'Arquivos', postgres: 'PostgreSQL' },
  },
};

type Widen<T> = { [K in keyof T]: T[K] extends string ? string : Widen<T[K]> };
export type Messages = Widen<typeof ptBR>;
